import React, { useEffect, useState } from 'react';
import { GlobalContext } from '../components/Context/Context';
import { useStrapiSingle, useStrapiCollection } from '../components/Strapi/strapiCollection';
import { useContext } from 'react';
import AboutUsContent from '../components/AboutUsContent/AboutUsContent';
import { useMemo } from 'react';

const AboutUs = () => {
    const [BtsSEO, setBtsSEO] = useState({});
    const [aboutUsSEO, setAboutUsSEO] = useState({});
    const { globalServerStrapi } = useContext(GlobalContext);

    // Google Analytics
    // const { trackPageView, trackEvent } = useGoogleAnalytics();

    // Get SEO Data for BTS
    const {
        data: strapiBtsSEO,
        loading: strapiBtsSEOLoading,
        error: strapiBtsSEOError
    } = useStrapiSingle('seo-bts');

    useEffect(() => {
        if (strapiBtsSEO) {
            setBtsSEO(strapiBtsSEO);
        }
        if (strapiBtsSEOError) {
            console.error("Error loading SEO Bts:", strapiBtsSEOError);
        }
    }, [strapiBtsSEO, strapiBtsSEOLoading, strapiBtsSEOError]);


    // Get SEO Data for News

    const seoFilters = useMemo(
        () => ({ Page_Id: 'AboutUs' }),
        []
    );

    const {
        data: strapiAboutUsSEO,
        loading: strapiAboutUsSEOLoading,
        error: strapiAboutUsSEOError
    } = useStrapiCollection(
        'seo-pages',
        '=*',
        'id',
        'asc',
        1,
        seoFilters
    );

    useEffect(() => {
        if (strapiAboutUsSEO) {
            setAboutUsSEO(strapiAboutUsSEO[0]);
        }
        if (strapiAboutUsSEOError) {
            console.error("Error loading SEO for AboutUs:", strapiAboutUsSEOError);
        }
    }, [strapiAboutUsSEO, strapiAboutUsSEOLoading, strapiAboutUsSEOError]);



    return (
        <>
            {/* React Document Metadata */}
            <title>{aboutUsSEO?.metaTitle || 'BTS - About Us'}</title>
            <meta name="description" content={aboutUsSEO?.metaDescription || 'Default description'} />
            <meta name="keywords" content={aboutUsSEO?.metaKeywords || 'Default keywords'} />

            {/* Open Graph */}
            <meta property="og:title" content={aboutUsSEO?.metaTitle || 'Belize Tax Service'} />
            <meta property="og:description" content={aboutUsSEO?.metaDescription || 'Default description'} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={BtsSEO?.Website_Name} />
            <meta property="og:image" content={globalServerStrapi + aboutUsSEO?.ogImage?.url || '/default-og-image.jpg'} />
            <meta property="og:image:width" content={aboutUsSEO?.ogImageWidth} />
            <meta property="og:image:height" content={aboutUsSEO?.ogImageHeight} />
            <meta property="og:image:alt" content={aboutUsSEO?.ogImageAlt || 'Belize Tax Service'} />
            <meta property="og:image:type" content={aboutUsSEO?.ogImageType} />

            {/* Twitter Cards */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={aboutUsSEO?.metaTitle || 'Belize Tax Service'} />
            <meta name="twitter:description" content={aboutUsSEO?.metaDescription || 'Default description'} />
            <meta name="twitter:image" content={globalServerStrapi + aboutUsSEO?.ogImage?.url || '/default-og-image.jpg'} />

            {/* Canonical URL */}
            <link rel="canonical" href={BtsSEO?.Organization_URL} />

            {/* Schema.org JSON-LD */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": BtsSEO?.Organization_Name || "Belize Tax Service",
                        "url": BtsSEO?.Organization_URL,
                        "logo": globalServerStrapi + BtsSEO?.Organization_Logo?.url || "/logo.png",
                        "description": aboutUsSEO?.metaDescription || "Organization description",
                        "sameAs": BtsSEO?.Social_Networks?.map(red => red.URL).filter(url => url) || []
                    })
                }}
            />

            <div className='container boxed-container home-area'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <AboutUsContent />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutUs;

